import React, { Component, Fragment } from 'react'
import { Button, Popconfirm, Popover, Steps } from 'antd'
import Member from '../../../components/Sales/ClientRegistration/Form/Member'
import MemberList from '../../../components/Sales/ClientRegistration/Form/MemberList'
import RepresentativeContactList from '../../../components/Sales/ClientRegistration/Form/RepresentativeContactList'
import RepresentativeContact from '../../../components/Sales/ClientRegistration/Form/RepresentativeContact'
import ContractDetails from '../../../components/Sales/ClientRegistration/Form/ContractDetails'
import Summary from '../../../components/Sales/ClientRegistration/Summary'

const Step = Steps.Step

class ClientRegistrationForm extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    const {
      current,
      next,
      prev,
      skip,
      approve,
      confirmLoading,
      memberRef,
      bankRef,
      refRef,
      contractRef,
      refAccountRef,
      refLogisticRef,
    } = this.props

    const customDot = (dot, { status, index }) => (
      <Popover
        content={
          <span>
            step {index} status: {status}
          </span>
        }>
        {dot}
      </Popover>
    )

    const StepsAction = () => (
      <div
        className="steps-action"
        style={
          current !== steps.length - 1
            ? { margin: '9px 35% 17px 44%' }
            : { margin: '9px 31% 17px 36%' }
        }>
        {current > 0 && (
          <Button style={{ marginLeft: 8 }} onClick={prev}>
            Previous
          </Button>
        )}
        {current < steps.length - 1 &&
        (steps[current].confirmation ? (
          <Popconfirm
            title={steps[current].confirmation}
            onConfirm={next}
            okText="Create"
            cancelText="Cancel"
            style={{ marginLeft: 17 }}>
            <Button loading={confirmLoading} type="primary" style={{ marginLeft: 17 }}>
              {steps[current].nextText ? steps[current].nextText : 'Next'}
            </Button>
          </Popconfirm>
        ) : (
          <Button
            loading={confirmLoading}
            type="primary"
            style={{ marginLeft: 17 }}
            onClick={() => next()}>
            {steps[current].nextText ? steps[current].nextText : 'Next'}
          </Button>
        ))}

        {current === 7 && (
          <Button style={{ marginLeft: 8 }} onClick={skip}>
            Skip
          </Button>
        )}

        {current === 5 && (
          <Button style={{ marginLeft: 8 }} onClick={skip}>
            Skip
          </Button>
        )}

        {current === steps.length - 1 && (
          <Button type="primary" onClick={() => approve(this.state)} style={{ marginLeft: 17 }}>
            Complete Registration !
          </Button>
        )}
      </div>
    )
    const steps = [
      {
        title: 'Existing Business Details',
        content: <MemberList {...this.props} />,
        index: 0,
        nextText: 'Create New',
        confirmation: 'Are you sure this Supplier does not already exist?',
      },
      {
        title: 'Business Details',
        content: <Member {...this.props} ref={memberRef}/>,
        index: 1,
      },
      {
        title: 'Trading Details',
        content: <ContractDetails {...this.props} ref={contractRef}/>,
        index: 2,
      },
      // {
      //   title: 'Existing Bank Account',
      //   content: <BankAccountList {...this.props} />,
      //   index: 3,
      //   nextText: 'Add New',
      //   confirmation: 'Are you sure this Bank does not already exist?',
      // },
      // {
      //   title: 'Bank Account',
      //   content: <BankAccount {...this.props} ref={bankRef} />,
      //   index: 4,
      // },
      {
        title: 'Existing Representative Contact',
        content: (
          <RepresentativeContactList
            {...this.props}
            type={'representative'}
            path={'representativeContact'}
          />
        ),
        index: 3,
        nextText: 'Add New',
        confirmation: 'Are you sure this Representative does not already exist?',
      },

      {
        title: 'Representative Contact',
        content: (
          <RepresentativeContact {...this.props} ref={refRef} path={'representativeContact'}/>
        ),
        index: 4,
      },

      {
        title: 'Existing Accounts Contact',
        content: <RepresentativeContactList {...this.props} type={'accounts'} path={'accounts'}/>,
        index: 5,
        nextText: 'Add New',
        confirmation: 'Are you sure this Representative does not already exist?',
      },

      {
        title: 'Accounts Contact',
        content: <RepresentativeContact {...this.props} ref={refAccountRef} path={'accounts'}/>,
        index: 6,
      },

      {
        title: 'Existing Logistics Coordinator',
        content: (
          <RepresentativeContactList {...this.props} type={'logistics'} path={'coordinator'}/>
        ),
        index: 7,
        nextText: 'Add New',
        confirmation: 'Are you sure this Representative does not already exist?',
      },

      {
        title: 'Logistics Coordinator',
        content: (
          <RepresentativeContact {...this.props} ref={refLogisticRef} path={'coordinator'}/>
        ),
        index: 8,
      },
      {
        title: 'Confirm Vendor Registration',
        content: <Summary {...this.props} />,
        index: 9,
      },
    ]

    const StepsProgressDots = () => (
      <Steps current={current} progressDot={customDot}>
        {steps.map(item => (
          <Step key={item.title} title={item.title}/>
        ))}
      </Steps>
    )

    return (
      <Fragment>
        <StepsProgressDots/>
        <StepsAction/>
        <Fragment className="steps-content">{steps[current].content}</Fragment>
      </Fragment>
    )
  }
}

export default ClientRegistrationForm
